module.exports = __webpack_public_path__ + "img/bon secours mercy health.86ab5f29.png";